import { html } from "lit";
import { property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { LeafElement } from "../leaf-element.js";
import { emit } from "../../utilities/events.js";
import { loadScript } from "../../utilities/loaders.js";
import { appendStylesheet } from "../../utilities/light-dom-styles.js";
const styles = '/* ------------------------------------ *\\\n#MULTIMEDIA\n\\* ------------------------------------ */\n/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.leaf-c-multimedia-limelight {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.leaf-c-multimedia-limelight::before {\n  --aspect-ratio: calc(9 / 16 * 100%);\n  content: "";\n  display: block;\n  padding-top: var(--aspect-ratio);\n}\n.leaf-c-multimedia-limelight > * {\n  height: 100% !important;\n  left: 0;\n  position: absolute !important;\n  top: 0;\n  width: 100% !important;\n}\n.leaf-c-multimedia-limelight:active {\n  background-color: var(--leafdcws-multimedia-active-bg);\n}\n.leaf-c-multimedia-limelight:active .vjs-has-started .vjs-text-track-display {\n  background-color: var(--leafdcws-multimedia-active-bg);\n}\n.leaf-c-multimedia-limelight:active .limelight-player .vjs-limelight-big-play {\n  background-color: var(--leafdcws-multimedia-active-bg);\n}\n.leaf-c-multimedia-limelight .vjs-control-bar {\n  background-color: var(--leaf-color-bg-brand-strong) !important;\n}\n\n.leaf-c-multimedia-limelight--audio {\n  height: 34px !important;\n}\n.leaf-c-multimedia-limelight--audio .vjs-limelight-big-play:before {\n  display: none;\n}\n\n.limelight-player .vjs-limelight-viewport {\n  overflow: visible;\n}\n.limelight-player .vjs-limelight-big-play {\n  opacity: unset;\n  text-shadow: none !important;\n  font-size: var(--leaf-font-size-10) !important;\n  border: var(--leaf-border-width-focus) solid var(--leafdcws-color-border-transparent);\n  border-radius: var(--leaf-border-radius-default);\n  overflow: hidden;\n}\n.limelight-player .vjs-limelight-big-play:before {\n  background-color: var(--leaf-color-bg-brand-strong);\n  border: 10px solid var(--leaf-color-border-knockout);\n  border-radius: var(--leaf-border-radius-round);\n  box-shadow: var(--leaf-shadow-default);\n  color: var(--leaf-color-content-knockout);\n}\n.limelight-player .vjs-limelight-big-play:hover, .limelight-player .vjs-limelight-big-play:active {\n  border-color: var(--leaf-color-border-brand);\n}\n.limelight-player .vjs-limelight-big-play:focus-visible {\n  border: var(--leaf-border-width-focus) solid var(--leaf-color-border-brand);\n  outline: var(--leaf-border-width-focus) solid var(--leafdcws-border-active-outline);\n  outline-offset: var(--leaf-border-width-focus);\n  overflow: hidden;\n}\n\n.limelight-audio .video-js .vjs-control-bar {\n  display: flex !important;\n}\n.limelight-audio .vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {\n  opacity: 1 !important;\n}\n.limelight-audio .vjs-limelight-big-play::before {\n  content: "" !important;\n}';
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const limelightPlayerCallback = (playerId, eventName, data) => {
  const container = document.getElementById(playerId);
  const player = container == null ? void 0 : container.querySelector("video, audio");
  switch (eventName) {
    case "onPlayerLoad": {
      const element = container == null ? void 0 : container.getElementsByClassName("video-js")[0];
      element == null ? void 0 : element.setAttribute("tabindex", "0");
      emit("leaf:load-player", {}, element);
      break;
    }
    case "onMediaLoad": {
      if (player) {
        player.setAttribute("aria-label", data.title);
        emit("leaf:load-media", {}, player);
      }
      break;
    }
    case "onMediaComplete": {
      if (player) {
        emit("leaf:finish-media", {}, player);
      }
      break;
    }
  }
};
class LeafMultimediaLimelight extends LeafElement {
  constructor() {
    super();
    this.contentType = "media";
    this.variant = "video";
    this.playerFormId = "cace1bc41a3c4b6fa3d4cc16e02333e2";
    this._playerId = "";
    this._isLoaded = false;
    appendStylesheet("tcg-multimedia-styles", styles);
  }
  get playerId() {
    return this._playerId;
  }
  connectedCallback() {
    super.connectedCallback();
    if (!this._playerId) {
      const num = Math.floor(Math.random() * 9e5) + 1e5;
      this._playerId = `limelight_player_${num}`;
    }
    this.addEventListeners();
  }
  async updated(changedProperties) {
    super.updated(changedProperties);
    const element = this.renderRoot.querySelector(`#${this.playerId}`);
    if (element) {
      element.innerHTML = "";
    }
    if (this.variant === "audio") {
      this.classList.add("limelight-audio");
    } else {
      this.classList.remove("limelight-audio");
    }
    const observer = new IntersectionObserver(
      async (entries) => {
        if (entries[0].isIntersecting === true && !this._isLoaded) {
          this._isLoaded = true;
          await this.embedVideo();
        }
      },
      { threshold: [0] }
    );
    observer.observe(this.renderRoot);
  }
  addEventListeners() {
    document.addEventListener("leaf:hide", (event) => {
      if (event.target instanceof HTMLElement && event.target.contains(this)) {
        event.stopPropagation();
        const player = this.querySelector("video, audio");
        player == null ? void 0 : player.pause();
      }
    });
  }
  /**
   * Embeds limelight_player to associated _playerId.
   */
  async embedVideo() {
    loadScript("//video.limelight.com/player/limelightjs-player.js").then(() => {
      if (!window.limelightPlayerCallback) {
        window.limelightPlayerCallback = limelightPlayerCallback;
      }
      LimelightPlayerUtil.embed({
        playerId: this.playerId,
        [`${this.contentType}Id`]: this.contentId,
        playerFormId: this.playerFormId
      });
    });
  }
  render() {
    const componentClassName = {
      "leaf-c-multimedia-limelight": true,
      "leaf-c-multimedia-limelight--audio": this.variant === "audio",
      "leaf-c-multimedia-limelight--video": this.variant === "video"
    };
    return html`<div class=${classMap(componentClassName)}>
      <div id="${this.playerId}"></div>
    </div>`;
  }
  createRenderRoot() {
    return this;
  }
}
__decorateClass([
  property()
], LeafMultimediaLimelight.prototype, "contentType", 2);
__decorateClass([
  property()
], LeafMultimediaLimelight.prototype, "contentId", 2);
__decorateClass([
  property()
], LeafMultimediaLimelight.prototype, "variant", 2);
__decorateClass([
  property({ type: String })
], LeafMultimediaLimelight.prototype, "playerFormId", 2);
export {
  LeafMultimediaLimelight
};
//# sourceMappingURL=multimedia-limelight.component.js.map
